import moment from 'moment';
import { globalGetService, globalExportService,  } from '../../utils_v2/globalApiServices';
import { checkApiStatus, downloadFileType, getLocalStorageInfo } from '../../utils_v2';
export function getAssetIdentifierApi(assetIdentifier, stateType, query={}){
  globalGetService(`contracts/v2/dashboard/lease-generic-filters/${assetIdentifier}/`,query)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({[stateType]:response.data.data})
    }
  })
}

export function getAssemblyApi(filterOption){
  globalGetService(`contracts/get_contract_asset_drop_down/?major_assemblies=true`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({assemblyOptions:response?.data?.data})
    }
  })
}
export function getFleetClaimsApi(props, query={}, loaderType, dataType){
  this.setState({[loaderType]:true});
  globalGetService(`contracts/claim-listing/`, query)
  .then(response => {
    this.setState({[loaderType]:false});
    if(checkApiStatus(response)){
      delete query.page;
      delete query.per_page;
      delete query.sort;
      delete query.sort_by;
      this.setState({
        invoices:response.data.data,
        filter:query
      });
      if(dataType){
        this.setState({open:true})
      }
    }
  })
}

export function exportFleetClaimApi(props,query){
  this.setState({pageLoader:true});
  globalGetService(`contracts/claim-listing/`,query)
  .then(response => {
    this.setState({pageLoader:false});
      if(checkApiStatus(response)){   
        this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      // downloadFileType(response?.data, `Fleet_Claim_Listing_${getLocalStorageInfo().defaultLessor.name}_${moment().format('YYYY-MM-DD')}`, 'xlsx')
      }
    // this.props.enqueueSnackbar('Fleet Claim Exported Successfully', {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
  })
}


export function getClaimsListApi(props, query, loaderType){
  this.setState({[loaderType]:true});
  globalGetService(`contracts/${props?.params?.type}/${props?.params?.aircraft_slug}/claim-listing/`,query)
  .then(response => {
    this.setState({[loaderType]:false});
    if(checkApiStatus(response)){
      delete query.page;
      delete query.per_page;
      delete query.sort;
      delete query.sort_by;
      this.setState({claims:response.data.data, filter:query})
    }
  })
}

export function exportClaimApi(props={},query){
  this.setState({pageLoader:true});
  globalExportService(`contracts/${props?.params?.type}/${props?.params?.aircraft_slug}/claim-listing/`,query)
  .then(response => {
    this.setState({pageLoader:false});
    if(response?.data){
      downloadFileType(response?.data, `${props?.params?.type.charAt(0).toUpperCase() + props?.params?.type.slice(1)}_Claims_${getLocalStorageInfo().defaultLessor.name}_${moment().format('YYYY-MM-DD')}`, 'xlsx')
    }
    props.enqueueSnackbar(`${props?.params?.type.charAt(0).toUpperCase() + props?.params?.type.slice(1)} Claim Exported Successfully`, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
  })
}















